import { connect } from "react-redux";
import { Link } from "react-router-dom";
import React, { Fragment, useState } from "react";
import * as Yup from "yup";

import Button from "../UI/Button";
import CardHeading from "../UI/Headings/CardHeading";
import CardSecondary from "../UI/Card/CardSecondary";
import { changePassword } from "../../redux/actions/auth";
import { ContainerContent } from "../Common/Dashboard/ContainerContent";
import { ContainerTitle } from "../Common/Dashboard/ContainerTitle";
import { CustomForm } from "../../component-library/CustomForm";
import FormikInput from "../UI/FormikInput";
import { getAutomationDataAttr } from "../../utils/automationUtils";
import images from "../../utils/images";
import { logOut } from "../../redux/actions/logout";
import { yup_password_factory } from "../../utils/yupSchemaUtils";

const ChangePassword = (props) => {
  const { baseRoute } = props;
  const [popUp, showPopup] = useState(false);

  const changePassword = (form, actions) => {
    let formCopy = Object.assign({}, form);

    delete formCopy.confirmNewPassword;
    props.changePassword(formCopy, (success) => {
      actions.setSubmitting(false);
      if (success) {
        actions.resetForm();
        showPopup((prevState) => {
          return true;
        });
      }
    });
  };
  const logOut = () => {
    props.logOut({ history: props.history });
  };

  const forgotPassword = () => {
    const redirect = "/auth/forgot-password";
    const useRedirectScreen = true;

    props.logOut({
      history: props.history,
      redirectPath: redirect,
      useRedirectScreen,
    });
  };

  const validationSchema = Yup.object().shape({
    confirmNewPassword: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("new_password"), null], "Password does not match"),
    current_password: yup_password_factory("Current Password is required"),
    new_password: yup_password_factory(),
  });
  //Add Old Password New Password and Confirm new Password

  return (
    <Fragment>
      {popUp && (
        <div className="popup" {...getAutomationDataAttr("ChangePasswordSuccessPopUp")}>
          <div className="container">
            <div className="popup-card px-3 py-5 px-lg-5 text-center">
              <div className="d-flex mb-4 tw:justify-center">
                <img className="img-fluid" src={images("./common/successCheck.svg")} />
              </div>
              <p className="tw:font-bold">Password Change Successfully!</p>
              <p className="my-3">
                Your password has been reset successfully. Please login with your new password
              </p>
              <Button
                className="Btn Btn--pri Btn-sm"
                onClick={logOut}
                {...getAutomationDataAttr("ChangePasswordSuccessOkButton")}
              >
                OK
              </Button>
            </div>
          </div>
        </div>
      )}

      <ContainerContent>
        <ContainerTitle title="Password" />

        <CustomForm
          initialValues={{
            confirmNewPassword: "",
            current_password: "",
            new_password: "",
          }}
          onSubmit={changePassword}
          render={(formikProps) => (
            <form onSubmit={formikProps.handleSubmit}>
              <CardSecondary className="PatientProfile__ProfileDetailsCard p-3 p-lg-3 mb-3 mb-lg-4">
                <CardHeading
                  className="patient-profile-purple fs-16 pt-2 mb-0 d-none d-lg-block"
                  text="Change Password"
                />
                <hr className="m-0 d-none d-md-block my-1" />
                <div className="row pt-3 pt-lg-0">
                  <div className="col-12 col-lg-6">
                    <FormikInput
                      errors={formikProps.errors}
                      formEl={{
                        elementConfig: {
                          label: "Current Password",
                          placeholder: "Enter Current Password",
                          type: "password",
                        },
                        elementType: "input",
                        name: "current_password",
                      }}
                      testId="ChangePasswordCurrentPassword"
                      touched={formikProps.touched}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <FormikInput
                      errors={formikProps.errors}
                      formEl={{
                        elementConfig: {
                          label: "New Password",
                          placeholder: "Enter New Password",
                          type: "password",
                        },
                        elementType: "input",
                        name: "new_password",
                      }}
                      testId="ChangePasswordNewPassword"
                      touched={formikProps.touched}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <FormikInput
                      errors={formikProps.errors}
                      formEl={{
                        elementConfig: {
                          label: "Confirm New Password",
                          placeholder: "Confirm New Password",
                          type: "password",
                        },
                        elementType: "input",
                        name: "confirmNewPassword",
                      }}
                      testId="ChangePasswordConfirmNewPassword"
                      touched={formikProps.touched}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <Button
                      className="Btn Btn-link txt-sec"
                      onClick={forgotPassword}
                      style={{ margin: 0 }}
                    >
                      <b>Forgot Password?</b>
                    </Button>
                  </div>
                </div>
                <div className="justify-content-end d-none d-md-flex pb-2">
                  <Link to={baseRoute + "/settings"}>
                    <Button className="Btn Btn--otl-pri mx-3">Cancel</Button>
                  </Link>
                  <Button
                    className="Btn Btn--pri mx-3"
                    disabled={formikProps.isSubmitting}
                    type="submit"
                    {...getAutomationDataAttr("SubmitChangePasswordButton")}
                  >
                    Confirm
                  </Button>
                </div>
              </CardSecondary>
              <div className="ChangePassword-Btn-Wpr text-center d-flex justify-content-between d-block d-md-none mt-4">
                <Link to={baseRoute + "/settings"}>
                  <Button className="Btn Btn--otl-pri">Cancel</Button>
                </Link>
                <div>
                  <Button
                    className="Btn Btn--pri"
                    disabled={formikProps.isSubmitting}
                    type="submit"
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            </form>
          )}
          validationSchema={validationSchema}
        />
      </ContainerContent>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { changePassword, logOut })(ChangePassword);
